module.exports = __webpack_public_path__ + "img/Alberto Hayon.fe8d140b.png";